import HttpService from '@/endpoints/HttpService';
import { LockerRoomDrawingConfiguration } from '@/models/lockers/lockerRoomDrawingConfiguration';

const baseUrl = `${process.env.VUE_APP_API_PREFIX}LockerRoomDrawingConfigurations`;

export default class LockerRoomDrawingConfigurationsService {
  public static async getForRoom(roomId: string): Promise<LockerRoomDrawingConfiguration | null> {
    const response = await HttpService.get(`${baseUrl}/${roomId}`);
    return response.data.entity ?? null;
  }

  public static async updateForRoom(roomId: string, request: LockerRoomDrawingConfiguration): Promise<void> {
    await HttpService.put(`${baseUrl}/${roomId}`, request);
  }
}
